var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { StackedDualBarChart, arrayUtils } from "../../../Charts";
import { Loader } from "../../../components/Elements/Loader";

const countriesTemplate = '58b2f3a35d59f31e1345b480';
const countryKey = 'pa_s';

class CejilChart extends Component {
  componentDidMount() {
    this.props.getData.call(this).then(([groupedResults, setA, setB]) => {
      this.setState({ groupedResults, setA, setB });
    });
  }

  render() {
    let output = /*#__PURE__*/_jsx(Loader, {});

    if (this.state && this.state.groupedResults) {
      const { aggregations } = this.state.groupedResults;

      let data = arrayUtils.sortValues(
        aggregations.all[countryKey].buckets.
        filter(
          (country) =>
          country.filtered.doc_count && country.key !== 'any' && country.key !== 'missing'
        ).
        map((_country) => {
          const country = _country;
          country.results = country.filtered.doc_count;
          return country;
        })
      );

      data = this.props.prepareData.call(this, data, this.state.setA, this.state.setB);

      output = /*#__PURE__*/
      _jsx("div", { className: "item item-chart" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, this.props.label), /*#__PURE__*/
      _jsx(StackedDualBarChart, { data: data, chartLabel: this.props.label })
      );

    }

    return (/*#__PURE__*/
      _jsx("div", { className: "item-group-charts", style: { paddingTop: '15px', paddingRight: '15px' } }, void 0,
      output
      ));

  }
}

CejilChart.defaultProps = {
  label: null
};







export default CejilChart;
export { countriesTemplate, countryKey };